/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 14:51:00
 * @LastEditor: Chao Yang
 * @LastEditTime : 2020-01-08 10:37:05
 */
import { formatDate } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { FooterOption } from '../model/footer-option';

@Component({
  selector: 'ad-section-footer-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent implements OnInit {
  date: Date;
  currentYear: string;
  footerClass = 'ad-footer-default';
  options: FooterOption;
  @Input() set option(val: FooterOption) {
    if (!this.checkObjectIsDefined(val)) {
      return;
    }
    this.options = val;
    if (this.checkStringIsDefinfed(this.options.branding)) {
      this.footerClass = 'ad-footer-default ad-footer-' + this.options.branding;
    } else {
      this.footerClass = 'ad-footer-default';
    }
  }

  constructor() { }

  checkObjectIsDefined(obj: any): boolean {
    if (obj === undefined || obj === null) {
      return false;
    }
    return true;
  }

  checkStringIsDefinfed(str: string): boolean {
    return this.checkObjectIsDefined(str) && str !== '';
  }

  clickAlterDomus(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    window.open(this.options.homeSite, '_blank');
  }

  clickCorProSupportEmail(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    location.href = 'mailto:' + this.options.email;
  }

  clickCorProSupportPhone(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    location.href = 'tel:' + this.options.phone;
  }

  clickPrivacyShieldNotice(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    window.open(this.options.privacyShieldNotice, '_blank');
  }

  ngOnInit() {
    this.date = new Date();

    this.currentYear = formatDate(this.date, "yyyy", "en-US");
  }
}
